"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePackageTemplateRequestToJSON = exports.UpdatePackageTemplateRequestFromJSONTyped = exports.UpdatePackageTemplateRequestFromJSON = exports.instanceOfUpdatePackageTemplateRequest = void 0;
const runtime_1 = require("../runtime");
const OnTrackNotifications_1 = require("./OnTrackNotifications");
const OnTrackRules_1 = require("./OnTrackRules");
const PackageBillingRateType_1 = require("./PackageBillingRateType");
const PackageContentType_1 = require("./PackageContentType");
const PackageDepositRule_1 = require("./PackageDepositRule");
const PackageExpiration_1 = require("./PackageExpiration");
const PackageFrequency_1 = require("./PackageFrequency");
const PackagePaymentOptionRequest_1 = require("./PackagePaymentOptionRequest");
const PackageTemplateItem_1 = require("./PackageTemplateItem");
const PackageTemplatePayloadCouponsInner_1 = require("./PackageTemplatePayloadCouponsInner");
const PackageTemplatePayloadPaymentSettings_1 = require("./PackageTemplatePayloadPaymentSettings");
const PackageTimeType_1 = require("./PackageTimeType");
const PackageType_1 = require("./PackageType");
const ServiceFeeRequestType_1 = require("./ServiceFeeRequestType");
const SmartActionTemplateExtended_1 = require("./SmartActionTemplateExtended");
const UpdatePackageTemplateRequestAllOfTiersInner_1 = require("./UpdatePackageTemplateRequestAllOfTiersInner");
const UsagePackageInvoicing_1 = require("./UsagePackageInvoicing");
/**
 * Check if a given object implements the UpdatePackageTemplateRequest interface.
 */
function instanceOfUpdatePackageTemplateRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "icon" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "paymentOptions" in value;
    return isInstance;
}
exports.instanceOfUpdatePackageTemplateRequest = instanceOfUpdatePackageTemplateRequest;
function UpdatePackageTemplateRequestFromJSON(json) {
    return UpdatePackageTemplateRequestFromJSONTyped(json, false);
}
exports.UpdatePackageTemplateRequestFromJSON = UpdatePackageTemplateRequestFromJSON;
function UpdatePackageTemplateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': json['title'],
        'slug': json['slug'],
        'description': json['description'],
        'internalName': !(0, runtime_1.exists)(json, 'internalName') ? undefined : json['internalName'],
        'icon': json['icon'],
        'items': (json['items'].map(PackageTemplateItem_1.PackageTemplateItemFromJSON)),
        'paymentOptions': (json['paymentOptions'].map(PackagePaymentOptionRequest_1.PackagePaymentOptionRequestFromJSON)),
        'secret': !(0, runtime_1.exists)(json, 'secret') ? undefined : json['secret'],
        'publicOrder': !(0, runtime_1.exists)(json, 'publicOrder') ? undefined : json['publicOrder'],
        'distributeSessions': !(0, runtime_1.exists)(json, 'distributeSessions') ? undefined : json['distributeSessions'],
        'totalSessions': !(0, runtime_1.exists)(json, 'totalSessions') ? undefined : json['totalSessions'],
        'contentType': !(0, runtime_1.exists)(json, 'contentType') ? undefined : (0, PackageContentType_1.PackageContentTypeFromJSON)(json['contentType']),
        'timeType': !(0, runtime_1.exists)(json, 'timeType') ? undefined : (0, PackageTimeType_1.PackageTimeTypeFromJSON)(json['timeType']),
        'autocomplete': !(0, runtime_1.exists)(json, 'autocomplete') ? undefined : json['autocomplete'],
        'packageType': !(0, runtime_1.exists)(json, 'packageType') ? undefined : (0, PackageType_1.PackageTypeFromJSON)(json['packageType']),
        'frequency': !(0, runtime_1.exists)(json, 'frequency') ? undefined : (0, PackageFrequency_1.PackageFrequencyFromJSON)(json['frequency']),
        'rollOver': !(0, runtime_1.exists)(json, 'rollOver') ? undefined : json['rollOver'],
        'billingRateId': !(0, runtime_1.exists)(json, 'billingRateId') ? undefined : json['billingRateId'],
        'packageBillingRateType': !(0, runtime_1.exists)(json, 'packageBillingRateType') ? undefined : (0, PackageBillingRateType_1.PackageBillingRateTypeFromJSON)(json['packageBillingRateType']),
        'acceptedOutcomes': !(0, runtime_1.exists)(json, 'acceptedOutcomes') ? undefined : json['acceptedOutcomes'],
        'autoCancelOutcome': !(0, runtime_1.exists)(json, 'autoCancelOutcome') ? undefined : json['autoCancelOutcome'],
        'usageInvoicing': !(0, runtime_1.exists)(json, 'usageInvoicing') ? undefined : (0, UsagePackageInvoicing_1.UsagePackageInvoicingFromJSON)(json['usageInvoicing']),
        'allowFutureBooking': !(0, runtime_1.exists)(json, 'allowFutureBooking') ? undefined : json['allowFutureBooking'],
        'locked': !(0, runtime_1.exists)(json, 'locked') ? undefined : json['locked'],
        'depositRule': !(0, runtime_1.exists)(json, 'depositRule') ? undefined : (0, PackageDepositRule_1.PackageDepositRuleFromJSON)(json['depositRule']),
        'coupons': !(0, runtime_1.exists)(json, 'coupons') ? undefined : (json['coupons'].map(PackageTemplatePayloadCouponsInner_1.PackageTemplatePayloadCouponsInnerFromJSON)),
        'onTrackEnabled': !(0, runtime_1.exists)(json, 'onTrackEnabled') ? undefined : json['onTrackEnabled'],
        'enableAtRisk': !(0, runtime_1.exists)(json, 'enableAtRisk') ? undefined : json['enableAtRisk'],
        'smartActions': !(0, runtime_1.exists)(json, 'smartActions') ? undefined : (json['smartActions'] === null ? null : json['smartActions'].map(SmartActionTemplateExtended_1.SmartActionTemplateExtendedFromJSON)),
        'onTrackNotifications': !(0, runtime_1.exists)(json, 'onTrackNotifications') ? undefined : (0, OnTrackNotifications_1.OnTrackNotificationsFromJSON)(json['onTrackNotifications']),
        'onTrackRules': !(0, runtime_1.exists)(json, 'onTrackRules') ? undefined : (0, OnTrackRules_1.OnTrackRulesFromJSON)(json['onTrackRules']),
        'tiers': !(0, runtime_1.exists)(json, 'tiers') ? undefined : (json['tiers'] === null ? null : json['tiers'].map(UpdatePackageTemplateRequestAllOfTiersInner_1.UpdatePackageTemplateRequestAllOfTiersInnerFromJSON)),
        'serviceFee': !(0, runtime_1.exists)(json, 'serviceFee') ? undefined : (0, ServiceFeeRequestType_1.ServiceFeeRequestTypeFromJSON)(json['serviceFee']),
        'earliestStartDate': !(0, runtime_1.exists)(json, 'earliestStartDate') ? undefined : (json['earliestStartDate'] === null ? null : new Date(json['earliestStartDate'])),
        'paymentSettings': !(0, runtime_1.exists)(json, 'paymentSettings') ? undefined : (0, PackageTemplatePayloadPaymentSettings_1.PackageTemplatePayloadPaymentSettingsFromJSON)(json['paymentSettings']),
        'expiration': !(0, runtime_1.exists)(json, 'expiration') ? undefined : (0, PackageExpiration_1.PackageExpirationFromJSON)(json['expiration']),
        'cancellationFormTemplateId': !(0, runtime_1.exists)(json, 'cancellationFormTemplateId') ? undefined : json['cancellationFormTemplateId'],
        'allowClientTierChanges': !(0, runtime_1.exists)(json, 'allowClientTierChanges') ? undefined : json['allowClientTierChanges'],
    };
}
exports.UpdatePackageTemplateRequestFromJSONTyped = UpdatePackageTemplateRequestFromJSONTyped;
function UpdatePackageTemplateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'slug': value.slug,
        'description': value.description,
        'internalName': value.internalName,
        'icon': value.icon,
        'items': (value.items.map(PackageTemplateItem_1.PackageTemplateItemToJSON)),
        'paymentOptions': (value.paymentOptions.map(PackagePaymentOptionRequest_1.PackagePaymentOptionRequestToJSON)),
        'secret': value.secret,
        'publicOrder': value.publicOrder,
        'distributeSessions': value.distributeSessions,
        'totalSessions': value.totalSessions,
        'contentType': (0, PackageContentType_1.PackageContentTypeToJSON)(value.contentType),
        'timeType': (0, PackageTimeType_1.PackageTimeTypeToJSON)(value.timeType),
        'autocomplete': value.autocomplete,
        'packageType': (0, PackageType_1.PackageTypeToJSON)(value.packageType),
        'frequency': (0, PackageFrequency_1.PackageFrequencyToJSON)(value.frequency),
        'rollOver': value.rollOver,
        'billingRateId': value.billingRateId,
        'packageBillingRateType': (0, PackageBillingRateType_1.PackageBillingRateTypeToJSON)(value.packageBillingRateType),
        'acceptedOutcomes': value.acceptedOutcomes,
        'autoCancelOutcome': value.autoCancelOutcome,
        'usageInvoicing': (0, UsagePackageInvoicing_1.UsagePackageInvoicingToJSON)(value.usageInvoicing),
        'allowFutureBooking': value.allowFutureBooking,
        'locked': value.locked,
        'depositRule': (0, PackageDepositRule_1.PackageDepositRuleToJSON)(value.depositRule),
        'coupons': value.coupons === undefined ? undefined : (value.coupons.map(PackageTemplatePayloadCouponsInner_1.PackageTemplatePayloadCouponsInnerToJSON)),
        'onTrackEnabled': value.onTrackEnabled,
        'enableAtRisk': value.enableAtRisk,
        'smartActions': value.smartActions === undefined ? undefined : (value.smartActions === null ? null : value.smartActions.map(SmartActionTemplateExtended_1.SmartActionTemplateExtendedToJSON)),
        'onTrackNotifications': (0, OnTrackNotifications_1.OnTrackNotificationsToJSON)(value.onTrackNotifications),
        'onTrackRules': (0, OnTrackRules_1.OnTrackRulesToJSON)(value.onTrackRules),
        'tiers': value.tiers === undefined ? undefined : (value.tiers === null ? null : value.tiers.map(UpdatePackageTemplateRequestAllOfTiersInner_1.UpdatePackageTemplateRequestAllOfTiersInnerToJSON)),
        'serviceFee': (0, ServiceFeeRequestType_1.ServiceFeeRequestTypeToJSON)(value.serviceFee),
        'earliestStartDate': value.earliestStartDate === undefined ? undefined : (value.earliestStartDate === null ? null : value.earliestStartDate.toISOString().substr(0, 10)),
        'paymentSettings': (0, PackageTemplatePayloadPaymentSettings_1.PackageTemplatePayloadPaymentSettingsToJSON)(value.paymentSettings),
        'expiration': (0, PackageExpiration_1.PackageExpirationToJSON)(value.expiration),
        'cancellationFormTemplateId': value.cancellationFormTemplateId,
        'allowClientTierChanges': value.allowClientTierChanges,
    };
}
exports.UpdatePackageTemplateRequestToJSON = UpdatePackageTemplateRequestToJSON;
//# sourceMappingURL=UpdatePackageTemplateRequest.js.map